import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import './contenido.css';

const Contenido = ({ loading, categorias, contenidoHtml }) => {
  const [t, i18n] = useTranslation("detail_blog");

  const trackAnalyticsClick = (label) => {
    window.gtag('event', 'click', {
      event_category: 'Detalle Blog',
      event_label: label,
      value: 1
    });
  };

  const cleanHtml = () => {
    if (!contenidoHtml) return "";

    let html = contenidoHtml;

    // eliminar styles
    html = html.replace(/<style[\s\S]*?<\/style>/gi, "");

    // eliminar scripts
    html = html.replace(/<script[\s\S]*?<\/script>/gi, "");

    // eliminar bloque audio desktop
    html = html.replace(
      /<div id="btn-voz-rbs">[\s\S]*?<\/div>/gi,
      ""
    );

    // eliminar bloque audio mobile
    html = html.replace(
      /<div id="btn-voz-rbs-mov">[\s\S]*?<\/div>/gi,
      ""
    );

    // coso random
    html = html.replace(
      /style="margin-top: -9%;"/gi,
      ""
    );

    // eliminar footer viejo de El Universal
    html = html.replace(
      /\*Este artículo fue publicado[\s\S]*?<\/p>/gi,
      ""
    );

    // eliminar footer viejo de El Universal
    html = html.replace(
      /Este artículo fue publicado[\s\S]*?<\/p>/gi,
      ""
    );

    html = html.replace(
      /Comparto en este espacio mi art(?:í|&iacute;)culo[\s\S]*?<\/p>/gi,
      ""
    );


    // quitar wrappers viejos
    html = html.replace(/<div id="entrada">/gi, "");
    html = html.replace(/<div id="general">/gi, "");

    // quitar divs vacíos sobrantes
    //html = html.replace(/<\/div>\s*<\/div>/gi, "</div>");

    return html;
  };

  const extractUniversalLink = () => {
    const match = contenidoHtml?.match(
      /(?:Este art(?:í|&iacute;)culo fue publicado|Comparto en este espacio mi art(?:í|&iacute;)culo)[\s\S]*?<a[^>]*href="([^"]+)"/i
    );

    return match ? match[1] : null;
  };

  const universalLink = extractUniversalLink();

  if (loading) {
    return (
      <div class="_ngcontent-ng-c1842723448 _nghost-ng-c2709612515">
        <div className="blog-detail-header-skeleton blog-detail-story-content">
          <div className="blog-detail-pla">

            <div class="blog-detail-header__meta-row">
              <div className="skeleton skeleton-meta" />
            </div>

            <div className="skeleton skeleton-title" />

            <div class="blog-detail-header__meta-row">
              <div className="skeleton skeleton-meta" />
            </div>

            <div className="skeleton skeleton-image blog-detail-hero__image" />

          </div>
        </div>
      </div >
    );
  } else {
    return (
      <>
        <div class="_ngcontent-ng-c1842723448 _nghost-ng-c2709612515">
          <section class="blog-detail-story-content">
            <div className="blog-detail-pla"
              dangerouslySetInnerHTML={{
                __html: cleanHtml(),
              }}
            />
          </section>
        </div>
        <div id="coments" class="_ngcontent-ng-c1842723448 _nghost-ng-c3228204868">
          <section class="blog-detail-footer">
            <div aria-label="Temas del articulo" class="blog-detail-footer__tags">
              {Array.isArray(categorias) &&
                categorias.map((item, index) => (
                  <a  onClick={() => trackAnalyticsClick('Detalle Blog - Categoria: '+item.tagCategory.toLowerCase())} href={"/" + i18n.language + "/Mi-blog?categoria=" + item.tagCategory.toLowerCase()}>
                    <span key={index}>{item.nombre}</span>
                  </a>
                ))
              }
            </div>
            {universalLink && (
              <p class="blog-detail-footer__origin blog-detail-footer__origin--mobile">
                *Este artículo fue publicado en mi espacio de opinión en{" "}
                <a onClick={() => trackAnalyticsClick('Detalle Blog - Liga: El universal')}
                  href="https://www.eluniversal.com.mx/"
                  target="_blank"
                  rel="noreferrer"
                >
                  El Universal
                </a>
              </p>
            )}
            <div class="blog-detail-footer__meta blog-detail-footer__meta--desktop">
              {universalLink && (
                <p className="blog-detail-footer__origin blog-detail-footer__origin--desktop">
                  *Este artículo fue publicado en mi espacio de opinión en{" "}
                  <a onClick={() => trackAnalyticsClick('Detalle Blog - Liga: El universal')}
                    href={universalLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    El Universal
                  </a>
                </p>
              )}
              <a onClick={() => trackAnalyticsClick('Detalle Blog - Todos los blogs')} 
                class="blog-detail-footer__back-link"
                href={"/" + i18n.language + "/Mi-blog"}>{(t('2026.back'))}</a>
            </div>
          </section>
        </div>
      </>
    );
  }
};

export default Contenido;
